import Spinner from "react-bootstrap/Spinner";
import {useState, useEffect} from 'react';
import {NFTStorage, File} from 'nft.storage'
import {Buffer} from 'buffer';
import axios from 'axios';
import {useCurrentAccount, useSuiClientQuery} from '@mysten/dapp-kit';
import {useSignAndExecuteTransactionBlock} from "@mysten/dapp-kit";
import {TransactionBlock} from "@mysten/sui.js/transactions";
import NFT from "../constants/NFT.json";

const CreateNft = () => {


    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [image, setImage] = useState(null)
    const [url, setURL] = useState(null)

    const [message, setMessage] = useState("")
    const [isWaiting, setIsWaiting] = useState(false)
    const currentAccount = useCurrentAccount();
    const {mutate: signAndExecute} = useSignAndExecuteTransactionBlock();
    const submitHandler = async (e) => {
        e.preventDefault()
        console.log('current user :', {currentAccount});
        if (!currentAccount) {
            window.alert("Please connect your wallet!")
            return
        }
        if (name === "" || description === "") {
            window.alert("Please provide a name and description")
            return
        }

        setIsWaiting(true)

        // Call AI API to generate a image based on description
        const imageData = await createImage()

        // Upload image to IPFS (NFT.Storage)
        const url = await uploadImage(imageData)

        // Mint NFT
        await mintImage(url)

        setIsWaiting(false)
        setMessage("")
    }

    const createImage = async () => {
        setMessage("Generating Image...");
    
        const URL = `https://api-inference.huggingface.co/models/stabilityai/stable-diffusion-xl-base-1.0`;
    
        try {
            const response = await axios({
                url: URL,
                method: "POST",
                headers: {
                    Authorization: `Bearer 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`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({
                    inputs: description, // Ensure description is a valid string
                    options: { wait_for_model: true },
                }),
                responseType: "arraybuffer",
            });
    
            const type = response.headers["content-type"];
            const data = response.data;
    
            const base64data = Buffer.from(data).toString("base64");
            const img = `data:${type};base64,` + base64data;
            setImage(img);
            setMessage("Image generated successfully!");
    
            return data;
        } catch (error) {
            if (error.response) {
                const errorDetails = Buffer.from(error.response.data).toString("utf8");
                console.error("API Error Response:", errorDetails);
            }
            setMessage("Failed to generate image. Please try again.");
            console.error("Error:", error);
        }
    };
    

    // const uploadImage = async (imageData) => {
    //     setMessage("Uploading Image...")
    //     const nftstorage = new NFTStorage({token: 'd3d2a75e.1a67e484c2c4458c96d0acdec8a706fe'})
    //     const {data} = await nftstorage.store({
    //         image: new File([imageData], "image.jpeg", {type: "image/jpeg"}),
    //         name: name,
    //         description: description,
    //     })
    //     const path_url = data.image.pathname.replace("//", "");
    //     const images_url = `https://ipfs.io/ipfs/${path_url}`
    //     console.log(images_url)
    //     return images_url
    // }

    const uploadImage = async (imageData) => {
    try {
        setMessage("Uploading Image...");

        const nftstorage = new NFTStorage({
        token: process.env.REACT_APP_NFT_STORAGE_API_KEY || "d3d2a75e.1a67e484c2c4458c96d0acdec8a706fe",
        });

        const metadata = await nftstorage.store({
        image: new File([imageData], "image.jpeg", { type: "image/jpeg" }),
        name: "My NFT Image",
        description: "This is a description for my NFT image.",
        });

        const path_url = new URL(metadata.image).pathname.replace("//", "");
        const images_url = `https://ipfs.io/ipfs/${path_url}`;

        console.log("Uploaded image URL:", images_url);
        setMessage("Upload successful!");
        return images_url;
    } catch (error) {
        console.error("Error uploading image:", error.message || error);
        setMessage("Upload failed. Please try again.");
    }
    };


    const mintImage = async (nftImageUrl) => {
        setMessage("Waiting for Mint...")

        const txb = new TransactionBlock();
        txb.moveCall({
            arguments: [txb.pure(name), txb.pure(description), txb.pure(nftImageUrl)],
            target: `${NFT.PACKAGE_ID}::${NFT.MODULE_NAME}::${NFT.MINT_FUNCTION}`,
        });

        signAndExecute(
            {
                transactionBlock: txb,
                options: {
                    // We need the effects to get the objectId of the created counter object
                    showEffects: true,
                },
            },
            {
                onSuccess: (tx) => {
                    console.log("onSuccess ...");
                    // The first created object in this TransactionBlock should be the new Counter
                    const objectId = tx.effects?.created?.[0]?.reference?.objectId;
                    console.log(objectId);
                    if (objectId) {
                        setURL(`https://suiexplorer.com/object/${objectId}?network=devnet`)
                    }
                },
            },
        )


    }


    return (
        <div>
            <div className='form'>
                <form onSubmit={submitHandler}>
                    <input type="text" placeholder="Create a name..." onChange={(e) => {
                        setName(e.target.value)
                    }}/>
                    <input type="text" placeholder="Create a description..."
                           onChange={(e) => setDescription(e.target.value)}/>
                    <input type="submit" value="Create & Mint"/>
                </form>
                <div className="image">
                    {!isWaiting && image ? (
                        <img src={image} alt="AI generated image"/>
                    ) : isWaiting ? (
                        <div className="image__placeholder">
                            <Spinner animation="border"/>
                            <p>{message}</p>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            {!isWaiting && url && (
                <p>
                    View&nbsp;<a href={url} target="_blank" rel="noreferrer">NFT Metadata</a>
                </p>
            )}
        </div>
    );
}

export default CreateNft;